import { render, staticRenderFns } from "./DashboardSpModal.vue?vue&type=template&id=2b7a6100&scoped=true&"
import script from "./DashboardSpModal.vue?vue&type=script&lang=ts&"
export * from "./DashboardSpModal.vue?vue&type=script&lang=ts&"
import style0 from "./DashboardSpModal.vue?vue&type=style&index=0&id=2b7a6100&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b7a6100",
  null
  
)

export default component.exports